module.exports = __webpack_public_path__ + "static/media/isb-brand.d6c0bddc.webp";